/// <amd-module name="Test/Analytics/Common/Utils/TelemetryService" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import * as TcmTelemetryConstants from "Test/Analytics/Common/Utils/TcmTelemetryConstants";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { FilterValueItem } from "Test/common-util/TestResults.Filtering.Common";
import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

// Logs information to customer intelligence service
// @param(feature) = featureName
// @param(key) = key of the information value
// @param(value) = information value
export function publishEvent(
    pageContext: IVssPageContext,
    feature: string,
    properties: { [key: string]: any },
    testReportContext: CommonTypes.ITestReportContext,
    confValues: CommonTypes.IReportConfiguration
) {
    try {
        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        let definitionIdType = "";
        switch (testReportContext.contextType) {
            case TCMContracts.TestResultsContextType.Build:
                definitionIdType = TcmTelemetryConstants.Build;
                break;
            case TCMContracts.TestResultsContextType.Release:
                definitionIdType = TcmTelemetryConstants.Release;
                break;
        }

        properties[TcmTelemetryConstants.Report] = TcmTelemetryConstants.TestFailures;

        if (confValues && confValues.configuredFilters && confValues.configuredFilters[CommonTypes.Filter.Workflow]) {
            properties[TcmTelemetryConstants.WorkFlow] = confValues.configuredFilters[CommonTypes.Filter.Workflow].values
                .map((w: FilterValueItem) => w.displayValue)
                .join(",");
        }

        properties[definitionIdType] = testReportContext.definitionId;

        telemetryService.publishEvent(TcmTelemetryConstants.area, feature, properties);
    } catch (e) {
        console.error(Utils_String.format("[TelemetryService.logProperties]: Error in logging Customer Intelligence data. Error: {0}", e.message));
    }
}
